import React from 'react';

import cls from 'classnames';

import { Container, Row, Col } from '@ott/grid';
import CoatOfArmsRF from '@ott/icon-coat-of-arms-rf';
import IATAIcon from '@ott/icon-iata';
import PCIIcon from '@ott/icon-pci-dss';
import { l10nhtml, l10n } from '@ott/l10n';

import { RU_LOCALE } from '../../constants';
import PaySystems from './blocks/PaySystems';
import Socials from './blocks/Socials';

import styles from './InfoSection.scss';

const InfoSection = ({
  lang,
  hasSocials,
  hasPayments,
  preCopyright,
  partnerCopyright,
  languageSwitcher,
}) => {
  const renderSocials = () => {
    if (lang !== RU_LOCALE || !hasSocials) {
      return null;
    }

    return (
      <div className={styles.socials}>
        <Socials />
      </div>
    );
  };

  const renderCertificates = () => {
    return (
      <div className={styles.certificates}>
        <IATAIcon monochrome={true} className={cls(styles.icon, styles.iconWhite)} />
        <PCIIcon monochrome={true} className={cls(styles.icon, styles.iconWhite)} />
        <CoatOfArmsRF className={styles.icon} />
        <span className={styles.infoText}>{l10n('footer.registerOfTourOperator')}</span>
      </div>
    );
  };

  const renderPaySystems = () => {
    if (!hasPayments) {
      return null;
    }

    return (
      <div data-locator="PaySystems" className={styles.iconsContainer}>
        <PaySystems lang={lang} />
      </div>
    );
  };

  const currentYear = new Date().getFullYear();
  return (
    <div className={styles.container}>
      <Container>
        <div className={styles.paySystems}>{renderPaySystems()}</div>
        <Row>
          <Col className={styles.copyrightColumn} desktop={9} mobile={4}>
            {lang === RU_LOCALE && renderCertificates()}
            <div className={styles.copyright} data-locator="footer-copyright">
              {preCopyright}
              {l10nhtml('footer.copyright', { year: currentYear })}
              {partnerCopyright && (
                <div className={styles.copyrightPartner}>{partnerCopyright}</div>
              )}
            </div>
          </Col>
          <Col mobile={4} desktop={3}>
            {renderSocials()}
            {languageSwitcher && <div className={styles.languageSwitcher}>{languageSwitcher}</div>}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default React.memo(InfoSection);
